export default __webpack_public_path__ + "locales/pl/ChangePhoneDialog.json?hash=70696ca3078957f532462d571f3d404a";